/** Ignore clearly invalid legacy values (seconds parsed as ms land here). */
const MIN_VALID_MS = Date.UTC(2000, 0, 1);

/**
 * Normalizes assorted API timestamp shapes to epoch milliseconds.
 * Handles unix seconds, unix milliseconds, and ISO/date strings.
 */
export function normalizeMessageTimestampValue(rawTimestamp) {
  if (rawTimestamp == null || rawTimestamp === '') return null;

  if (typeof rawTimestamp === 'number') {
    if (!Number.isFinite(rawTimestamp)) return null;
    return rawTimestamp > 9999999999 ? rawTimestamp : rawTimestamp * 1000;
  }

  if (typeof rawTimestamp === 'string') {
    const trimmed = rawTimestamp.trim();
    if (!trimmed) return null;

    const numeric = Number(trimmed);
    if (!Number.isNaN(numeric) && /^-?\d+(\.\d+)?$/.test(trimmed)) {
      return numeric > 9999999999 ? numeric : numeric * 1000;
    }

    const date = new Date(trimmed);
    return Number.isNaN(date.getTime()) ? null : date.getTime();
  }

  if (rawTimestamp instanceof Date) {
    return Number.isNaN(rawTimestamp.getTime()) ? null : rawTimestamp.getTime();
  }

  return null;
}

function collectTimestampCandidates(message) {
  if (!message || typeof message !== 'object') return [];

  return [
    message.timestamp,
    message.created_at,
    message.createdAt,
    message?.status?.timestamp,
  ];
}

/**
 * Resolves the best timestamp for a raw intervene message object.
 * Prefers plausible values and falls back to created_at when timestamp is legacy garbage.
 */
export function getMessageTimestampMs(message) {
  const candidates = collectTimestampCandidates(message);
  let fallback = null;

  for (const candidate of candidates) {
    const normalized = normalizeMessageTimestampValue(candidate);
    if (normalized == null) continue;

    if (normalized >= MIN_VALID_MS) return normalized;
    if (fallback == null) fallback = normalized;
  }

  return fallback;
}
